import { FC } from "react";
import { DropdownIndicatorProps } from "react-select";
import classNames from "classnames";
import { Icon } from "capitalrx-components-2.0/lib/general";
import styles from "../../styles.module.scss";
import { CustomReactSelectProps } from "../../CustomReactSelectProps";
import { OptionItem } from "../../OptionItem";

/**
 * The dropdown indicator component.
 */
export const DropdownIndicator: FC<DropdownIndicatorProps<OptionItem | null>> = (props) => {
  const { isDisabled, selectProps } = props;

  if (isDisabled || (selectProps as CustomReactSelectProps).isReadOnly) return null;

  return <Icon className={classNames(styles.Arrow, "arrow")} name="chevron-down" size="regular" />;
};
